import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, labelModes, states } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'
import info from '@/components/info'
import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import preloader from '@/components/preloader'
import routesFormLink from '@/components/services/routes/form/link'

const serviceNameViaPoint = Services['otp-settings/channels'].split('/').join('.')

function renderHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.tab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.tab = event
        }
      }
    }
  )
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.templates`)
      }
    }
  )
}
function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.warnings.templates`),
        color: Colors.warning
      }
    }
  )
}

function renderLinkToTemplate(h, item) {
  if (this.checkPermissions(`advanced.${Services['otp-settings/templates'].split('/').join('.')}.create`)) {
    return h(
      routesFormLink,
      {
        props: {
          value: { id: item.otpTemplateSettingsId },
          service: Services['otp-settings/templates'].split('/').join('.')
        }
      }
    )
  }
}
function renderTemplateField(h, item) {
  return h(
    components.select,
    {
      props: {
        value: item.otpTemplateSettingsId,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.templates`),
        service: Services['otp-settings/templates'],
        picks: [ 'id', 'name', 'channelType' ],
        itemTitle: 'name',
        itemsDisabled: this.proxy.otpChannelTemplateSettings.map(({ otpTemplateSettingsId }) => {
          return otpTemplateSettingsId
        }),
        query: { channelType: this.proxy.channelType },
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          item.otpTemplateSettingsId = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name
              }
            }
          )
        },
        item: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name,
                as: 'text'
              }
            }
          )
        }
      }
    }
  )
}
function renderGeneratorRow(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy.otpChannelTemplateSettings,
        defaultValue: {
          otpTemplateSettingsId: undefined,
          priority: 0
        },
        sortable: true
      },
      scopedSlots: {
        row: ({ item }) => {
          let gridTemplateColumns = '1fr'
          if (this.checkPermissions(`advanced.${serviceNameViaPoint}.create`)) {
            gridTemplateColumns = '1fr auto'
          }

          return h(
            'div',
            {
              class: 'grid grid-gap--8',
              style: { 'grid-template-columns': gridTemplateColumns }
            },
            [
              renderTemplateField.call(this, h, item),
              renderLinkToTemplate.call(this, h, item)
            ]
          )
        },
        footer: () => {
          return renderFooter.call(this, h)
        }
      },
      on: {
        input: event => {
          this.proxy.otpChannelTemplateSettings = event
        }
      }
    }
  )
}
function renderBody(h) {
  if (this.restData[Services['otp-settings/templates']].find.state === states.loading) {
    return h(preloader)
  }

  if (this.restData[Services['otp-settings/templates']].find.state === states.ready) {
    if (this.restData[Services['otp-settings/templates']].find.pagination.total === 0) {
      return renderWarning.call(this, h)
    }
  }

  return [
    renderInfo.call(this, h),
    renderGeneratorRow.call(this, h)
  ]
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.save,
            label: this.getTranslate('misc.buttons.save'),
            color: Colors.primary,
            mode: buttonModes.flat,
            loading: this.loading,
            disabled: this.attachDisabled
          },
          on: {
            click: () => {
              this.attachTemplates()
            }
          }
        }
      )
    ]
  )
}

function renderTab(h, key) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pa-2',
      props: {
        rounded: true,
        outline: true
      },
      key
    },
    [ renderBody.call(this, h) ]
  )
}

function renderContent(h) {
  return h(
    components.tabs,
    {
      props: { value: this.tab },
      scopedSlots: {
        body: () => {
          return this.tabs.map(tab => {
            return renderTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
